import { rotinasExpedicao } from "./rotinas"


export default function () {
  return rotinasExpedicao; 
}